import { useEffect, useState } from 'react';

import viewShippingProfiles from '@/shared/api/shipping/profiles/viewShippingProfiles';
import useRedirectLogin from '@/shared/hooks/useRedirectLogin';
import ShippingProfile from '@/shared/types/shipping/shippingProfile.type';

type Args = {
  profileId: string;
  updatedShippingProfile?: ShippingProfile[] | null;
};

const useFetchShippingProfile = ({
  profileId,
  updatedShippingProfile,
}: Args) => {
  const redirectLogin = useRedirectLogin();

  const [shippingProfile, setShippingProfile] = useState<
    ShippingProfile[] | null
  >(null);

  useEffect(() => {
    updatedShippingProfile && setShippingProfile(updatedShippingProfile);
  }, [updatedShippingProfile]);

  useEffect(() => {
    const fetchShippingProfile = async () => {
      const response = await viewShippingProfiles({
        body: {
          search: [{ shipping_profile_id: { cop: ['='], value: profileId } }],
        },
        onUnauthorized: redirectLogin,
      });

      if (response.success) {
        setShippingProfile(response.data);
      }
    };

    void fetchShippingProfile();
  }, [profileId, redirectLogin]);

  return {
    shippingProfile: shippingProfile?.[0],
  };
};

export default useFetchShippingProfile;
